import { FileProcessorPanel } from "../helpers/FileProcessorPanel";
import { processSupplyConstants } from "../../../lib/api_routes/aiToolkit";
import { TOOL_TYPES } from "../../../utils/aiToolkitInfo";

export function SupplyConstantsForm() {
  return (
    <FileProcessorPanel
      title="Supply Constants"
      toolType={TOOL_TYPES.SUPPLY_CONSTANTS}
      activityKey="ai_toolkit_supply_constants"
      processFn={processSupplyConstants}
      downloadFileName="Supply_Constants_Output.xlsx"
      toolSelectionRoute="/AiToolkit/Supplier_Demand_Constants"
    />
  );
}
